import apiClient from "./client";

export const getPageContent = async ({ page, language = "en" }) => {
  const response = await apiClient.get("/content", {
    params: { page, language },
  });
  return response.data;
};

